import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WarningTwoToneSvg from "@ant-design/icons-svg/es/asn/WarningTwoTone";
import AntdIcon from "../components/AntdIcon";
var WarningTwoTone = function WarningTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WarningTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WarningTwoTone.displayName = 'WarningTwoTone';
}
export default /*#__PURE__*/React.forwardRef(WarningTwoTone);